const model = {
    groupDetails: null,
    loading: false,
    error: null,
};

export default model;